import state from './chatState'
import mutations from './chatMutations'
import getters from './chatGetters'
import actions from './chatActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
